import React from 'react';
import CommonComponent from '../CommonComponent';
import { appMethod as app } from '@utils/app';

import './ShowVipModal.less';


export class ShowVipModal extends CommonComponent {
  constructor(props) {
    super(props);

    this.state = {
      shopVipModal: {
        showModal: false,
        isUp: false
      },
      cdnUrl: app.getCdnUrl()
    }
  }

  componentDidMount(){
  }

  show = (options) => {
    if(options.shopVipModal){
      this.setState({
        shopVipModal: options.shopVipModal
      })
    }
  }

  stopPropagation = (e) => {
    e.stopPropagation();
  }
  
  closeModal = () => {
    this.setData({
      'shopVipModal.showModal': false
    });
  }

  turnToVipCard = () => {
    app.turnToPage('/userCenter/pages/vipCardList/vipCardList');
    this.closeModal();
  }


  render(){
    let { shopVipModal, cdnUrl } = this.state;
    if(!shopVipModal.showModal){
      return null;
    }
    return (
      <div className="common-component shopVipModal-wrap" onTouchMove={(e) => this.stopPropagation(e)} >
        {/* <!-- 成为店铺会员 --> */}
        {
          !shopVipModal.isUp && (
            <div className="shopVipModal-win shopVipModal-vip">
              <div className="shopVipModal-vip-top" style={{backgroundImage:'url(' + cdnUrl + '/static/webapp/images/shop_vip.png)'}}>
                <div className="shopVipModal-closes-wrap"><label onClick={this.closeModal} className="ico-moon icon-closes shopVipModal-closes"></label></div>
                <div className="shopVipModal-p">恭喜你成为本店会员</div>
                <div className="shopVipModal-p">获得一张会员卡，请到个人中心查看</div>
              </div>
              <button className="shopVipModal-button" onClick={this.turnToVipCard}>去查看</button>
            </div>
          )
        }
        {/* <!-- 店铺会员升级 --> */}
        {
          shopVipModal.isUp && (
            <div className="shopVipModal-win shopVipModal-upgrade">
              <div className="shopVipModal-upgrade-top" style={{backgroundImage:'url('+ cdnUrl +'/static/webapp/images/shop_vip_upgrade.png)'}}><label onClick={this.closeModal} className="ico-moon icon-closes shopVipModal-closes"></label></div>
              <div className="shopVipModal-upgrade-text">请到个人中心查看最新会员权益吧</div>
              <button className="shopVipModal-button" onClick={this.turnToVipCard}>去查看</button>
            </div>
          )
        }
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/common/show-vip-modal/ShowVipModal.jsx